export default {
  registered: 'registered',
  preOrder: 'preOrder',
  benchSetupComplete: 'benchSetupComplete',
  paired: 'paired',
  ownerCodeCreated: 'ownerCodeCreated',
  completed: 'complete',
}
